<template>
  <list
    v-if="$store.state.user.sections['variants']"
    :columns="columns"
    :modalCreate="modalCreate"
    :staticFilters="staticFilters"
    :removeLink="removeLink"
    :cardLink="cardLink"
    :isUpdate="true"
    :isAdd="true"
    :itemLink="itemLink"
    :setLink="setLink"
    :openItem="true"
    :fields="fields"
    :params="params"
    :searchDisable="false"
    :setImport="true"
    @change="change"
    :exportFields="exportFields"
    @changeFunction="changeFunction"
    v-model="val"
  />
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      exportFields: {
        Наименование: "name",
        "Штрих-кол": "barcode",
        Цена: "stock.price",
        Категория: "product.category.name",
        "ID товара у мерчанта": "barcode",
        ИКПУ: "product.category.code",

        // Товары: {
        //   field: "purchases",
        //   callback: (value) => {
        //     let purchase = "";
        //     for (let i = 0; i < value.length; i++) {
        //       purchase += value[i].title;
        //     }
        //     return purchase;
        //   },
        // },
      },
      staticFilters: [
        {
          title: "Скрыть товары без цен",
          titleKey: "with_price",
          key: "with_price",
          is_root: true,
          shop: true,
          default: "0",
          items: [
            {
              id: "0",
              title: "Показать все",
            },
            {
              id: "1",
              title: "Только с ценами",
            },
          ],
        },
      ],
      params: {
        per_page: 20,
        show: 1,
      },
      val: [],
      modalCreate: "season",
      fields: [
        {
          col: " col-12 col-md-12",
          key: "name",
          label: "Название (обмен данных)",
          type: "field",
          textType: "text",
        },

        {
          col: " col-12 col-md-12",
          key: "modification_name",
          label: "Модификация",
          type: "field",
          textType: "text",
        },
        {
          col: " col-12 col-md-6",
          key: "barcode",
          label: "Баркод",
          type: "field",
          textType: "text",
        },
        {
          col: " col-12 col-md-6",
          key: "exchange_id",
          label: "Доп. идентификатор",
          type: "field",
          textType: "text",
        },
        {
          col: "col-12",
          label: "Товар",
          key: "product",
          type: "select",
          modal: "product",
          selectKey: "name",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_variant",
      itemLink: "variants",
      setLink: "variants",
      columns: [
        {
          full: true,
          key: "name",
          title: "Название",
          disableLink: true,
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },

        {
          key: "barcode",
          title: "Баркод",
          disableLink: true,
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "product",
          title: "Товар",

          object: "name",
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "stock",
          title: "Цена",
          object: "price",
          disableLink: true,
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "stock",
          title: "Количество",
          object: "quantity",
          disableLink: true,
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },

        {
          detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
